import { CultureInfo } from '../culture-info.model';
import { CultureInfoSv } from './sv';

/**
 * @ignore
 */
export const CultureInfoSvAX: CultureInfo = {
  name: 'sv-AX',
  displayName: 'svenska (Åland)',
  iso3LanguageCode: 'swe',
  iso2LanguageCode: 'sv',
  ietfLanguageTag: 'sv-AX',
  parent: CultureInfoSv
};
